import dateFormat from "date-format";

import Navbar from "@/components/template-components/navbar";
import AppCtaButtonMobile from "@/components/app-cta/mobile-button";
import AccountButtons from "@/components/account-buttons";

import { PAGES, TRANSLATIONS_READY } from "@/common/consts";
import { isClientSide } from "@/common/functions";
import data from "./data";
/**
 * HEADER
 *
 * The header.
 *
 */
export default {
	name: "Header",
	components: {
		Navbar,
		AppCtaButtonMobile,
		AccountButtons,
	},
	computed: {
		isWordCookiesPage() {
			return this.$route.name === PAGES.WORDCOOKIES;
		},
		isMobileMenuOpen() {
			return this.$store.getters.burgerActive;
		},
		mobileHeaderTop() {
			return {
				top: `${this.$store.state.window.smartBannerHeight +
					this.currentHeaderScroll}px`,
			};
		},
		desktopHeaderTop() {
			if (this.isSmallOrMediumDevice)
				return {
					top: `${Math.min(
						this.lowestScroll,
						Math.max(this.currentHeaderScroll, this.highestScroll)
					) +
						this.$store.state.window.topAdHeight +
						this.$store.state.window.smartBannerHeight}px`,
				};
			else
				return {
					top: `${this.currentHeaderScroll +
						this.$store.state.window.topAdHeight}px`,
				};
		},
		headerTopIndent() {
			// Since we're talking about pushing the header upwards, 'highestScroll' is an increasingly-negative number as the user scrolls downwards, and 'lowestScroll' is an increasingly-positive number as the user scrolls upwards.
			const newScrollY = this.scrollY;
			let newHeaderScroll;
			const searchOffsetDelay = this.$store.state.window
				.searchHeaderMobileHeight;
			if (newScrollY > 0) {
				let delta = this.currentWindowScroll - newScrollY;
				newHeaderScroll = this.currentHeaderScroll + delta;
				if (newHeaderScroll < this.highestScroll - searchOffsetDelay) {
					newHeaderScroll = this.highestScroll - searchOffsetDelay;
				} else if (newHeaderScroll > this.lowestScroll) {
					newHeaderScroll = this.lowestScroll;
				}
			} else {
				newHeaderScroll = 0;
			}
			if (this.isMobileMenuOpen) {
				newHeaderScroll = 0;
			}
			this.currentWindowScroll = newScrollY;
			this.currentHeaderScroll = newHeaderScroll;
			this.$store.commit(
				"updateVisibleHeaderHeight",
				Math.abs(this.highestScroll) +
					newHeaderScroll +
					searchOffsetDelay
			);

			if (this.isSmallDevice) {
				return this.mobileHeaderTop;
			} else {
				return this.desktopHeaderTop;
			}
		},
		highestScroll() {
			return -this.$store.state.window.headerHeight;
		},
		isNeedToShowCtaButton() {
			const lastVisitedTime = this.$store.getters.lastVisited || 0;

			// If the value is 0, it means the last visited cookie was never set, i.e. it's their first time here.
			if (lastVisitedTime === 0) return true;

			const currentTime = new Date();

			const lv = dateFormat.parse(
				dateFormat.ISO8601_WITH_TZ_OFFSET_FORMAT,
				lastVisitedTime
			);

			const diff = currentTime - lv;
			const max = 7 * 24 * 60 * 60 * 1000; // 7 Days,  in miliseconds.

			return diff > max;
		},
		isCtaButtonShow() {
			return this.isSmallOrMediumDevice;
		},
		scrollY() {
			return this.$store.state.window.scrollY;
		},
		showBorder() {
			if (
				this.isSmallDevice &&
				this.$route.name === PAGES.ARTICLE_DETAIL &&
				this.isFeatureEnabled("EnableArticleSearch")
			) {
				return false;
			}

			return true;
		},
		logoImage() {
			return isClientSide() ? "/static-wf/images/ic_wf_header.webp" : "";
		},
		logoBackupImage() {
			return isClientSide() ? "/static-wf/images/ic_wf_header.png" : "";
		},
	},
	methods: {
		dispatchGaEvent() {
			this.$store.dispatch("trackEvent", {
				ga: this.$ga,
				eventCategory: "Header",
				eventAction: "Click EN WF Logo navigation element",
				eventLabel: "EN WF Logo",
				eventID: 2,
			});
		},
	},
	mounted() {
		document.addEventListener(TRANSLATIONS_READY, () => {
			this.isTranslationsReady = true;
		});
		this.$store.commit("setHeaderHeight", this.$refs.header.clientHeight);
	},
	data,
};
